import React from 'react';
import styles from './WowBis.scss';
import classNames from 'classnames/bind';

import Adsense300250 from 'components/adsense/Adsense300250';
import Adsense700250 from 'components/adsense/Adsense700250';
import Adsense320100 from 'components/adsense/Adsense320100';
// import Adsense970250 from 'components/adsense/Adsense970250';

const cx = classNames.bind(styles);

let glang = 'kr';

const bisFilterBtnInfo = {
  'filter0': [
    {name_eng: 'Plate', name:'판금', id: 'isFan'},
    {name_eng: 'Mail', name:'사슬', id: 'isSasl'},
    {name_eng: 'Leather', name:'가죽', id: 'isGajuk'},
    {name_eng: 'Cloth', name:'천', id: 'isChun'},
  ],
  'filter1': [
    {name_eng: 'Cri', name:'치명', id: 'isCri'},
    {name_eng: 'Has', name:'가속', id: 'isHas'},
    {name_eng: 'Mas', name:'특화', id: 'isMas'},
    {name_eng: 'Ver', name:'유연', id: 'isVer'},
  ],
  'filter2': [
    {name_eng: 'Mainhand', name:'한손장비', id: 'isType0'},
    {name_eng: 'OffHand', name:'보조장비', id: 'isType1'},
    {name_eng: 'TwoHand', name:'양손장비', id: 'isType2'},
    {name_eng: 'Ranged', name:'원거리장비', id: 'isType3'},
    {name_eng: 'Head', name:'머리', id: 'isType4'},
    {name_eng: 'Shoulder', name:'어깨', id: 'isType5'},
    {name_eng: 'Back', name:'등', id: 'isType6'},
    {name_eng: 'Chest', name:'가슴', id: 'isType7'},
    {name_eng: 'Wrist', name:'손목', id: 'isType8'},
    {name_eng: 'Hands', name:'손', id: 'isType9'},
    {name_eng: 'Waist', name:'허리', id: 'isType10'},
    {name_eng: 'Legs', name:'다리', id: 'isType11'},
    {name_eng: 'Feet', name:'발', id: 'isType12'},
    {name_eng: 'Neck', name:'목', id: 'isType13'},
    {name_eng: 'Finger', name:'손가락', id: 'isType14'},
    {name_eng: 'Trinket', name:'장신구', id: 'isType15'},
  ],
  'filter3': [
    {name_eng: 'Str', name:'힘', id: 'isStr'},
    {name_eng: 'Agi', name:'민첩성', id: 'isAgi'},
    {name_eng: 'Int', name:'지능', id: 'isInt'}
  ],
  'filter4': [
    {name_eng: 'Mythic+', name:'쐐기', id: 'isM'},
    {name_eng: 'Aberrus', name:'레이드', id: 'isR'}
  ]
}

const BisItem = ({
  name, zone, voss, item_subclass, inventory_type, preview_item, level, item_id,
  imgsrc, cnt, item_class, dataSize
}) => {
  const {stats} = preview_item;
  let firstStatText = '';
  let secondStatText = '';

  if(!isNull(stats)) {
    stats.forEach(stat => {
      const {type} = stat.type;
      const {display} = stat;
      const {display_string} = display;

      if(type === 'CRIT_RATING' || type === 'HASTE_RATING' || type === 'MASTERY_RATING' || type === 'VERSATILITY') {
        secondStatText += display_string + '<br/>';
      }

      if(type === 'INTELLECT' || type === 'STRENGTH' || type === 'AGILITY') {
        firstStatText += display_string + '<br/>';
      }
    });
  }

  return (
    <>
    <li className={cx('item-content')}>
      {/* <div>{name+' , '+zone+','+voss+' , '+item_subclass.name+' , '+inventory_type.name+' , '+secondStatText+' , ' +firstStatText}</div> */}
      <div className={cx('ctt1')}>
        {/* {inventory_type.type +"|"+item_class.id}  */}
        {inventory_type.name}{inventory_type.type === 'CLOAK' ? '' : `(${item_subclass.name})`}
      </div>
      <div className={cx('ctt2')}>
        <img src={imgsrc} alt='아이템이미지' />
        <a href={`https://www.wowhead.com/${glang==='kr'?'ko':''}/item=${item_id}`} target="_blank" rel="noreferrer">{name} ({JSON.stringify(level)})</a> 
      </div>
      <div className={cx('ctt3')} dangerouslySetInnerHTML={{__html: firstStatText}} />
      <div className={cx('ctt4')} dangerouslySetInnerHTML ={{__html: secondStatText}} />
      <div className={cx('ctt5')}>{zone}<br/>{voss}</div>
    </li>
    <li className={cx('underline')}/>
    {(cnt > 6 && cnt%7===0) ? <div style={{textAlign:'center',margin:'2px 0px 2px 0px'}}><Adsense320100/><li className={cx('underline')}/></div> : <></>}
    </>
  );
};

const WowBis = ({wowBis, fnBisFilter, lang, fnFilterReset}) => {
  glang = lang;
  const {itemList, itemList_pending, bisFilter} = wowBis;
  const {
    isFan, isSasl, isGajuk, isChun, isCri, isHas, isMas, isVer,
    isType0, isType1, isType2, isType3, isType4, isType5,
    isType6, isType7, isType8, isType9, isType10, isType11, 
    isType12, isType13, isType14, isType15,
    isStr, isAgi, isInt, isM, isR
  } = bisFilter;

  const {allNo, allTypeNo, allSubStatNo, selStatCnt, allMainStatNo, allSlotNo, allContentNo} = isAllNo(isFan, isSasl, isGajuk, isChun, isCri, isHas, isMas, isVer, isType0, isType1, isType2, isType3, isType4, isType5, isType6, isType7, isType8, isType9, isType10, isType11,  isType12, isType13, isType14, isType15, isStr, isAgi, isInt, isM, isR);

  // {type: 'FEET', name: '발'}
  const filgerList = itemList.filter(data => {
    const {zone} = data;
    const {inventory_type, item_subclass, item_class, preview_item} = data.info;
    const {stats} = preview_item;
    const {
      noStat, isCriItem, isHasItem, isMasItem, isVerItem, isStrItem, isAgiItem, isIntItem
    } = isSubStatItem(stats);

    const isNonClassIDType = fnNonClassIDType(inventory_type.type);
    
    return (inventory_type.name === '착용 불가' ? false : true) && (
    allNo ? true : (
    (allTypeNo ? true : (
    //재질
    ((isFan === 'Y' && (item_class.id === 4 || item_class.id === 2) && (isNonClassIDType || item_subclass.id === 4)) ? true : false) || 
    ((isSasl === 'Y' && (item_class.id === 4 || item_class.id === 2) && (isNonClassIDType || item_subclass.id === 3)) ? true : false) ||
    ((isGajuk === 'Y' && (item_class.id === 4 || item_class.id === 2) && (isNonClassIDType || item_subclass.id === 2)) ? true : false) ||
    ((isChun === 'Y' && (item_class.id === 4 || item_class.id === 2) && (isNonClassIDType || item_subclass.id === 1)) ? true : false)
    )) &&
    (
    (allSubStatNo || noStat) ? true : (
    //2차스탯(선택옵션 2개이상)
    selStatCnt > 1 ? (
    ((isCri === 'Y' && isHas === 'Y' && isCriItem === 'Y' && isHasItem === 'Y') ? true : false) ||
    ((isCri === 'Y' && isMas === 'Y' && isCriItem === 'Y' && isMasItem === 'Y') ? true : false) ||
    ((isCri === 'Y' && isVer === 'Y' && isCriItem === 'Y' && isVerItem === 'Y') ? true : false) ||
    ((isHas === 'Y' && isMas === 'Y' && isHasItem === 'Y' && isMasItem === 'Y') ? true : false) ||
    ((isHas === 'Y' && isVer === 'Y' && isHasItem === 'Y' && isVerItem === 'Y') ? true : false) ||
    ((isMas === 'Y' && isVer === 'Y' && isMasItem === 'Y' && isVerItem === 'Y') ? true : false)
    ) : (
    //2차스탯(선택옵션 1개)
    ((isCri === 'Y' && isCriItem === 'Y') ? true : false) ||
    ((isHas === 'Y' && isHasItem === 'Y') ? true : false) ||
    ((isMas === 'Y' && isMasItem === 'Y') ? true : false) ||
    ((isVer === 'Y' && isVerItem === 'Y') ? true : false)
    )
    )
    ) && (
    allMainStatNo ? true : (
    ((isStr === 'Y' && (isStrItem === 'Y' || inventory_type.type === 'NECK' || inventory_type.type === 'FINGER')) ? true : false) ||
    ((isAgi === 'Y' && (isAgiItem === 'Y' || inventory_type.type === 'NECK' || inventory_type.type === 'FINGER')) ? true : false) ||
    ((isInt === 'Y' && (isIntItem === 'Y' || inventory_type.type === 'NECK' || inventory_type.type === 'FINGER')) ? true : false)
    )
    ) && (
    allSlotNo ? true : (
    ((isType0 === 'Y' && inventory_type.type === 'WEAPON') ? true : false) ||
    ((isType1 === 'Y' && (inventory_type.type === 'HOLDABLE'||inventory_type.type === 'SHIELD')) ? true : false) ||
    ((isType2 === 'Y' && inventory_type.type === 'TWOHWEAPON') ? true : false) ||
    ((isType3 === 'Y' && (inventory_type.type === 'RANGED' || inventory_type.type === 'RANGEDRIGHT')) ? true : false) ||
    ((isType4 === 'Y' && inventory_type.type === 'HEAD') ? true : false) ||
    ((isType5 === 'Y' && inventory_type.type === 'SHOULDER') ? true : false) ||
    ((isType6 === 'Y' && inventory_type.type === 'CLOAK') ? true : false) ||
    ((isType7 === 'Y' && (inventory_type.type === 'ROBE' || inventory_type.type === 'CHEST')) ? true : false) ||
    ((isType8 === 'Y' && inventory_type.type === 'WRIST') ? true : false) ||
    ((isType9 === 'Y' && inventory_type.type === 'HAND') ? true : false) ||
    ((isType10 === 'Y' && inventory_type.type === 'WAIST') ? true : false) ||
    ((isType11 === 'Y' && inventory_type.type === 'LEGS') ? true : false) ||
    ((isType12 === 'Y' && inventory_type.type === 'FEET') ? true : false) ||
    ((isType13 === 'Y' && inventory_type.type === 'NECK') ? true : false) ||
    ((isType14 === 'Y' && inventory_type.type === 'FINGER') ? true : false) ||
    ((isType15 === 'Y' && inventory_type.type === 'TRINKET') ? true : false)
    )
    ) && (
    allContentNo ? true : (
    (isR === 'Y' && zone === '아미드랏실' ? true : false) || 
    (isM === 'Y' && zone !== '아미드랏실' ? true : false)
    ) 
    )
    )
    );
  }).sort((a, b) => {
    return a.info.inventory_type.type > b.info.inventory_type.type ? 1 : -1;
  });
  
  const bisList = filgerList.map((data, cnt) => {
    const {zone, voss, imgsrc} = data;
    const {name, item_subclass, inventory_type, preview_item, level, id, item_class} = data.info;
    
    return <BisItem key={cnt}
      name={name}
      zone={zone}
      voss={voss}
      item_subclass={item_subclass}
      inventory_type={inventory_type}
      preview_item={preview_item}
      level={level}
      item_id={id}
      cnt={cnt}
      imgsrc={imgsrc}
      item_class={item_class}
      dataSize={filgerList.length}
    />
  })
  // .slice(0,5)
  ;

  const bisList_eng = filgerList.map((data, cnt) => {
    const {zone_eng, voss_eng, imgsrc} = data;
    const {name, item_subclass, inventory_type, preview_item, level, id, item_class} = data.info_eng;
    
    return <BisItem key={cnt}
      name={name}
      zone={zone_eng}
      voss={voss_eng}
      item_subclass={item_subclass}
      inventory_type={inventory_type}
      preview_item={preview_item}
      level={level}
      item_id={id}
      cnt={cnt}
      imgsrc={imgsrc}
      item_class={item_class}
      dataSize={filgerList.length}
    />
  })
  // .slice(0,5)
  ;

  const wowbisFilterRender = (gubun) => {

    const html = bisFilterBtnInfo[`filter${gubun}`].map((obj, cnt) => {
      const {name, id, name_eng} = obj;
      const checked = bisFilter[id] === 'Y' ? true : false;
      const checkedCss = {backgroundColor:'black',color:'white'};
      
      return (
        <li key={cnt} alt={name}>
          <input type="checkbox" id={id} onChange={fnBisFilter} alt={name} checked={checked} />
          <label htmlFor={id}><span style={checked ? checkedCss : null}>{glang==='kr'?name:name_eng}</span></label>
        </li>
      )
    });
  
    return html;
  }
  
  return (
    <section className={cx('main-contents')}>
      {/* {JSON.stringify((itemList[32]))}<br/><br/> */}
      {/* {JSON.stringify(bisFilter)} */}
      {/* <Adsense970250 /> */}
      <div className={cx('wowbis-null')}/>
      <div className={cx('wowbis-top')}>
        <div className={cx('wowbis-filter')}>
          <ul>{wowbisFilterRender('0')}</ul>
          <ul>{wowbisFilterRender('1')}</ul>
          <ul>{wowbisFilterRender('2')}</ul>
          <ul>{wowbisFilterRender('3')}</ul>
          <ul>{wowbisFilterRender('4')}</ul>
          <span className={cx('filter-reset')} onClick={fnFilterReset}>Filter Reset</span>
        </div>
        <div className={cx('wowbis-adsense1')}>
          <Adsense300250 />
        </div>
        <div className={cx('wowbis-adsense2')}>
          <Adsense700250 />
        </div>
        <div className={cx('wowbis-adsense3')}>
          <Adsense320100 />
        </div>
      </div>
      <div className={cx('wowbis-div')}>
        <ul className={cx('wowbis-title')}>
          <li className={cx('wowbis-row-title')}>
            <div className={cx('ctt1')}>{glang==='kr'?'부위(재질)':'Slot(type)'}</div>
            <div className={cx('ctt2')}>{glang==='kr'?'이름':'Item'}</div>
            <div className={cx('ctt3')}>{glang==='kr'?'주스탯':'MainStat'}</div>
            <div className={cx('ctt4')}>{glang==='kr'?'보조스탯':'SubStat'}</div>
            <div className={cx('ctt5')}>{glang==='kr'?'획득처':'Drop'}</div>
          </li>
        </ul>
        <ul className={cx('wowbis-ul')}>
          <li className={cx('underline')}/>
          {itemList_pending === 'Y' ? 
          <span className={cx('report_loading')}>
            <img src='/resource/img/loading_report.gif' alt='불러오는중' />
          </span> : 
          (lang === 'kr' ? bisList : bisList_eng)
          }
        </ul>
      </div>
    </section>
  )
}

export default WowBis;

const isNull = (value) => {
  return value === null || value === undefined;
}

const isAllNo = (isFan, isSasl, isGajuk, isChun, isCri, isHas, isMas, isVer, isType0, isType1, isType2, isType3, isType4, isType5, isType6, isType7, isType8, isType9, isType10, isType11,  isType12, isType13, isType14, isType15, isStr, isAgi, isInt, isM, isR) => {
  const allNo = isFan==='N' && isSasl==='N' && isGajuk==='N' && isChun==='N' && isCri==='N' && isHas==='N' && isMas==='N' && isVer==='N' &&
  isType0==='N' && isType1==='N' && isType2==='N' && isType3==='N' && isType4==='N' && isType5==='N' &&
  isType6==='N' && isType7==='N' && isType8==='N' && isType9==='N' && isType10==='N' && isType11==='N' && 
  isType12==='N' && isType13==='N' && isType14==='N' && isType15==='N' &&
  isStr==='N' && isAgi==='N' && isInt==='N' && isM==='N' && isR==='N' ? true : false;

  const allSubStatNo = isCri==='N' && isHas==='N' && isMas==='N' && isVer==='N' ? true : false;
  let selStatCnt = 0;
  if(isCri === 'Y') selStatCnt++;
  if(isHas === 'Y') selStatCnt++;
  if(isMas === 'Y') selStatCnt++;
  if(isVer === 'Y') selStatCnt++;

  const allTypeNo = isFan==='N' && isSasl==='N' && isGajuk==='N' && isChun==='N' ? true : false;
  const allMainStatNo = isStr==='N' && isAgi==='N' && isInt==='N' ? true : false;
  const allSlotNo = isType0==='N' && isType1==='N' && isType2==='N' && isType3==='N' && isType4==='N' && isType5==='N' &&
  isType6==='N' && isType7==='N' && isType8==='N' && isType9==='N' && isType10==='N' && isType11==='N' && 
  isType12==='N' && isType13==='N' && isType14==='N' && isType15==='N' ? true : false;

  const allContentNo = isM==='N' && isR==='N' ? true : false;

  return {
    allNo, allTypeNo, allSubStatNo, selStatCnt, allMainStatNo, allSlotNo, allContentNo
  }
}

const isSubStatItem = (stats) => {
  let isCriItem, isHasItem, isMasItem, isVerItem, isStrItem, isAgiItem, isIntItem = 'N';
  let noStat = true;
  
  if(isNull(stats)) {
    noStat = true;
  }else{
    noStat = false;

    stats.forEach(stat => {
      const {type} = stat.type;
  
      if(type === 'CRIT_RATING') {
        isCriItem = 'Y';
      }
      if(type === 'HASTE_RATING') {
        isHasItem = 'Y';
      }
      if(type === 'MASTERY_RATING') {
        isMasItem = 'Y';
      }
      if(type === 'VERSATILITY') {
        isVerItem = 'Y';
      }
  
      if(type === 'INTELLECT') isIntItem = 'Y';
      if(type === 'STRENGTH') isStrItem = 'Y';
      if(type === 'AGILITY') isAgiItem = 'Y';
    });
  }

  return {
    noStat, isCriItem, isHasItem, isMasItem, isVerItem, isStrItem, isAgiItem, isIntItem
  } 
}

const fnNonClassIDType = (inventory_type) => {
  return inventory_type === 'CLOAK' || inventory_type === 'WEAPON' || 
  inventory_type === 'TRINKET' || inventory_type === 'TWOHWEAPON' || 
  inventory_type === 'FINGER' || inventory_type === 'HOLDABLE' || 
  inventory_type === 'SHIELD' || inventory_type === 'NECK' || 
  inventory_type === 'RANGED' || inventory_type === 'RANGEDRIGHT'
  ? true : false;
}

